import React from 'react';

const authRoute = [
	{
		key: 'signIn',
		path: `/sign-in`,
		component: React.lazy(() => import('views/auth/SignIn')),
		authority: [],
		approved: false,
	},
	{
		key: 'signUp',
		path: `/sign-up`,
		component: React.lazy(() => import('views/auth/SignUp')),
		authority: [],
		approved: false,
	},
	{
		key: 'verifyEmail',
		path: `/verify-email`,
		component: React.lazy(() => import('views/auth/VerifyEmail')),
		authority: [],
		approved: false,
	},
	{
		key: 'forgotPassword',
		path: `/forgot-password`,
		component: React.lazy(() => import('views/auth/ForgotPassword')),
		authority: [],
		approved: false,
	},
	{
		key: 'resetPassword',
		path: `/reset-password`,
		component: React.lazy(() => import('views/auth/ResetPassword')),
		authority: [],
		approved: false,
	},
	{
		key: 'thanksForSigningUp',
		path: `/thanks-for-signing-up`,
		component: React.lazy(() => import('views/auth/ResetLinkVerification')),
		authority: [],
		approved: false,
	},
	{
		key: 'resetLinkVerification',
		path: `/reset-link-email-verification`,
		component: React.lazy(() => import('views/auth/ResetLinkVerification')),
		authority: [],
		approved: false,
	},
	{
		key: 'pages.invitation',
		path: '/invitation',
		component: React.lazy(() => import('views/auth/InvitationProcess')),
		authority: [],
		approved: false,
		meta: {
			pageContainerType: 'default',
			footer: true,
		},
	},
];

export default authRoute;
